import { GEnum } from '@/constants/enum.defination';
import { Serializable } from '@/models/core/serializable';
import { Student } from '@/models/student/student';
import { CustomCompetency } from '@/models/competency/competency';

export class StatsCompetencyBoxplot implements Serializable<StatsCompetencyBoxplot> {
  student: Student;
  competencyScores: Map<number, number>;
  selfEvalScores: Map<number, number>;

  deserialize(input: any): StatsCompetencyBoxplot {
    this.student = new Student().deserialize(input.student);
    if (input.competencyScores !== null) {
      this.competencyScores = Object.keys(input.competencyScores).reduce((result: Map<number, number>, dirtyCompetencyID: string) => {
        const competencyID: number = parseInt(dirtyCompetencyID);
        result.set(competencyID, parseFloat(input.competencyScores[dirtyCompetencyID]));
        return result;
      }, new Map<number, number>());
    }

    // 自己評価スコアが存在する場合取り込み
    if (input.selfEvalScores !== null) {
      this.selfEvalScores = Object.keys(input.selfEvalScores).reduce((result: Map<number, number>, dirtyCompetencyID: string) => {
        const competencyID: number = parseInt(dirtyCompetencyID);
        result.set(competencyID, parseFloat(input.selfEvalScores[dirtyCompetencyID]));
        return result;
      }, new Map<number, number>());
    }
    return this;
  }

  get otherCompetencyScores(): Map<number, number> {
    let result: Map<number, number> = new Map();

    let testedCompetencyIDs: number[] = [];
    const competencyIDIterator = this.competencyScores.keys();
    let item = competencyIDIterator.next();
    while (!item.done) {
      testedCompetencyIDs.push(item.value);
      item = competencyIDIterator.next();
    }

    if (
      testedCompetencyIDs.includes(GEnum.Competency.ID3) && //個人的実行力
      testedCompetencyIDs.includes(GEnum.Competency.ID18) //決断力
    ) {
      //主体性
      const individualityScore = (this.competencyScores.get(GEnum.Competency.ID3) + this.competencyScores.get(GEnum.Competency.ID18)) / 2;
      result.set(GEnum.BoxplotOtherCompetencyID.Individuality, individualityScore);
    }
    if (
      testedCompetencyIDs.includes(GEnum.Competency.ID9) && //自己効力
      testedCompetencyIDs.includes(GEnum.Competency.ID20) //影響力の行使
    ) {
      //協働性
      const collaboration = (this.competencyScores.get(GEnum.Competency.ID9) + this.competencyScores.get(GEnum.Competency.ID20)) / 2;
      result.set(GEnum.BoxplotOtherCompetencyID.Collaboration, collaboration);
    }
    if (
      result.has(GEnum.BoxplotOtherCompetencyID.Individuality) && //主体性
      result.has(GEnum.BoxplotOtherCompetencyID.Collaboration) //協働性
    ) {
      //リーダーシップ
      //NOTE: これだけ、その他のコンピテンシーどうしの組み合わせ（主体性と協働性）によって計算されるので、注意
      const leadership = (result.get(GEnum.BoxplotOtherCompetencyID.Individuality) + result.get(GEnum.BoxplotOtherCompetencyID.Collaboration)) / 2;
      result.set(GEnum.BoxplotOtherCompetencyID.Leadership, leadership);
    }
    if (
      testedCompetencyIDs.includes(GEnum.Competency.ID1) && //課題設定
      testedCompetencyIDs.includes(GEnum.Competency.ID17) //柔軟性
    ) {
      //イノベーション
      const innovation = (this.competencyScores.get(GEnum.Competency.ID1) + this.competencyScores.get(GEnum.Competency.ID17)) / 2;
      result.set(GEnum.BoxplotOtherCompetencyID.Innovation, innovation);
    }
    if (
      testedCompetencyIDs.includes(GEnum.Competency.ID6) && //疑う力
      testedCompetencyIDs.includes(GEnum.Competency.ID14) //表現力
    ) {
      //批判的思考力
      const criticalThinking = (this.competencyScores.get(GEnum.Competency.ID6) + this.competencyScores.get(GEnum.Competency.ID14)) / 2;
      result.set(GEnum.BoxplotOtherCompetencyID.CriticalThinking, criticalThinking);
    }
    if (
      testedCompetencyIDs.includes(GEnum.Competency.ID4) && //創造性
      testedCompetencyIDs.includes(GEnum.Competency.ID15) //共感・傾聴力
    ) {
      //創造的思考力
      const creativeThinking = (this.competencyScores.get(GEnum.Competency.ID4) + this.competencyScores.get(GEnum.Competency.ID15)) / 2;
      result.set(GEnum.BoxplotOtherCompetencyID.CreativeThinking, creativeThinking);
    }
    if (
      testedCompetencyIDs.includes(GEnum.Competency.ID12) && //耐性
      testedCompetencyIDs.includes(GEnum.Competency.ID15) //共感・傾聴力
    ) {
      //協働的思考力
      const collaborativeThinking = (this.competencyScores.get(GEnum.Competency.ID12) + this.competencyScores.get(GEnum.Competency.ID15)) / 2;
      result.set(GEnum.BoxplotOtherCompetencyID.CollaborativeThinking, collaborativeThinking);
    }

    return result;
  }


  customCompetencyScores(cCompetencies: CustomCompetency[]): Map<number, number> {
    let result: Map<number, number> = new Map();

    let testedCompetencyIDs: number[] = [];
    const competencyIDIterator = this.competencyScores.keys();
    let item = competencyIDIterator.next();
    while (!item.done) {
      testedCompetencyIDs.push(item.value);
      item = competencyIDIterator.next();
    }

    for (const cc of cCompetencies) {
      let count = 0;
      let scores = 0;
      for (const cid of cc.competencies) {
        if (testedCompetencyIDs.includes(cid)) {
          count++;
          scores += this.competencyScores.get(cid);
        }
      }
      if (count === cc.competencies.length) {
        result.set(cc.id, (scores / cc.competencies.length));
      }
    }

    return result;
  }

}
